<template>
  <el-dialog
    class="fill-dialog dialog"
    width="1000px"
    top="10px"
    :title="type"
    :visible="value"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('input', false)"
    append-to-body
  >
    <div>
      <el-form
        inline
        :model="formData"
        :rules="rulesFrom"
        ref="formData"
        class="demo-Form"
      >
        <el-form-item label="大题题号：" prop="th">
          <el-select
            v-model="formData.th"
            placeholder="请选择"
            style="width: 100px"
            size="small"
          >
            <el-option
              v-for="(item, i) in bigNumList"
              :key="i"
              :value="item"
              :label="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="limit-title" label="题目名称：" prop="name">
          <el-input
            class="topic_name"
            type="text"
            placeholder="请输入内容"
            v-model="formData.name"
            maxlength="27"
            show-word-limit
            size="small"
          ></el-input>
        </el-form-item>
        <!-- v-if="answerSheet.acCardYJType != 1" -->
        <el-form-item class="limit-title" style="margin-left: 290px">
          <el-checkbox v-model="formData.eachBlankScore">每空给分</el-checkbox>
        </el-form-item>
        <div></div>

        <div class="el-form-item">
          <label class="el-form-item__label">{{
            "题\xa0\xa0\xa0\xa0\xa0\xa0号："
          }}</label>
          <el-form-item prop="start" ref="start_inp">
            <IntegerInput v-model="formData.start" />
            <!-- <el-input-number v-model="formData.start" :controls="false" size="small" :min="1"></el-input-number> -->
          </el-form-item>
          <!-- <span class="dia-name" style="padding: 0 10px">至</span>
          <el-form-item prop="end" ref="end_inp">
            <IntegerInput v-model="formData.end" />
          </el-form-item> -->
        </div>
        <el-form-item :label="'小题号：'" prop="xTHValue" class="wh75">
          <el-select
            v-model="formData.xTHValue"
            placeholder="请选择"
            style="width: 100px"
            size="small"
          >
            <el-option
              v-for="(item, i) in formData.xThs"
              :key="i"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <span class="dia-name" style="padding: 0 10px">{{ thDescText }}</span>
        <el-form-item prop="end" ref="end_inp">
          <IntegerInput v-model="formData.end" />
        </el-form-item>
        <span class="dia-name" style="padding: 0 20px 0 0">题</span>
        <el-form-item
          :label="'每\xa0\xa0\xa0\xa0\xa0\xa0题：'"
          prop="score"
          class="wh75"
        >
          <el-input-number
            v-model="formData.score"
            :controls="false"
            :precision="2"
            size="small"
          ></el-input-number>
          <span>分</span>
        </el-form-item>
        <el-form-item
          :label="'每\xa0\xa0\xa0\xa0\xa0\xa0题：'"
          prop="tCount"
          class="wh75"
        >
          <el-input-number
            v-model="formData.tCount"
            :controls="false"
            size="small"
            :max="5"
          ></el-input-number>
          <span>空</span>
        </el-form-item>
        <el-form inline class="demo-Form" style="margin-top: 12px">
            <el-form-item label="每行：" prop="columnCount">
              <el-input-number
                v-model="formData.columnCount"
                :controls="false"
                size="small"
                :min="1"
                :max="formData.eachBlankScore ? 3 : 5"
                :step="1"
                :step-strictly="true"
              ></el-input-number>
              <span>空</span>
            </el-form-item>
          </el-form>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            circle
            size="mini"
            @click="addItems"
          ></el-button>
        </el-form-item>
      </el-form>

      <div class="dialog-cont">
        <el-button class="clear-table" type="text" @click="clear"
          >清空列表</el-button
        >
        <div class="dialog-list">
          <el-table
            :data="formData.items"
            height="300px"
            style="width: 100%"
            align="center"
          >
            <el-table-column label="题号">
              <template slot-scope="scope">
                <div
                  style="
                    display: flex;
                    justify-items: center;
                    align-items: center;
                  "
                >
                  <!-- <span style="display: block">{{ scope.row.no }}</span> -->
                  <el-input-number
                    :controls="false"
                    v-model="scope.row.no"
                    type="text"
                    size="small"
                  />
                  <span style="margin: 0 6px">{{
                    scope.row.xth == 0 ? "" : "."
                  }}</span>
                  <!-- <el-input
                    style="width: 120px"
                    v-model="scope.row.xth"
                    size="small"
                  ></el-input> -->
                  <span>{{ scope.row.xth == 0 ? "" : scope.row.xth }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="分值">
              <template slot-scope="scope">
                <el-input-number
                  style="width: 120px"
                  :controls="false"
                  v-model="scope.row.score"
                  type="number"
                  :precision="2"
                  size="small"
                />
              </template>
            </el-table-column>
            <el-table-column label="空数">
              <template slot-scope="scope">
                <el-input-number
                  style="width: 120px"
                  v-model="scope.row.tCount"
                  :controls="false"
                  size="small"
                  :max="5"
                  :min="1"
                  :step="1"
                  :step-strictly="true"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="操作" style="text-align: center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="deleteItem(scope)"
                  icon="el-icon-delete"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="submitBlank(formData)">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
//客观题
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import cardOperate from "@/assets/js/utils/cardOperate";
import { BlankModel, XTH_TYPE_KONG } from "./Blank.model";
import { overNum } from "@/utils/common";
import { ObjectiveModel } from "@/subjects/objective/Objective.model";
import { initTopicBoxMixins } from "@/mixins/initTopicBoxFormData.mixins";
export default {
  name: "subject-blank",
  props: ["value", "type", "subject"],
  mixins: [initTopicBoxMixins],
  computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    ...mapState("card", {
      bigNumList: (state) => state.THS,
    }),
  },
  methods: {
    creatItems() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          // 如果是编辑就追加题型
          // this.subject
          //   ? this.formData.addItems(this.formData)
          //   : this.formData.createItems(this.formData);
          if (this.subject) {
            let checkResult = false;
            checkResult = this.checkAll(checkResult);
            if (checkResult) {
              return;
            }
            const flag = overNum(this, 50);
            if (flag) return;
          } else {
            if (
              !this.formData.items.length &&
              this.formData.end - this.formData.start > 50
            ) {
              this.$message({
                message: "超出50题，无法添加！",
                type: "warning",
                customClass: "mzindex",
              });
              this.addButtonLoading = false;
              return;
            }
            let checkResult = false;
            checkResult = this.checkAll(checkResult);
            if (checkResult) {
              return;
            }
            const flag = overNum(this, 50);
            if (flag) return;
          }
          // 通过校验可以添加题型列表
          this.formData.addItems(this.formData) &&
            this.clearHistoryTopicFormData("creatItems");
        } else {
        }
      });
    },
    checkAll(checkResult) {
      checkResult = !checkResult && this.checkXTHToI(this.formData.xTHValue);
      checkResult =
        (!checkResult && this.checkXTHToA(this.formData.xTHValue)) ||
        checkResult;
      checkResult =
        (!checkResult && this.checkXTHToNumber(this.formData.xTHValue)) ||
        checkResult;
      checkResult =
        (!checkResult && this.checkXTHToNumberDouble(this.formData.xTHValue)) ||
        checkResult;
      return checkResult;
    },
    /**
     * 判断小题号类型 I II
     */
    checkXTHToI(value) {
      if (value == "Ⅰ") {
        if (this.formData.end > 12) {
          this.$message({
            message: "此类题型小题号不能超出12题！",
            type: "warning",
            customClass: "mzindex",
          });
          return true;
        }
      }
    },
    /**
     * 判断小题号类型 a b c d e
     */
    checkXTHToA(value) {
      if (value == "a") {
        if (this.formData.end > 12) {
          this.$message({
            message: "此类题型小题号不能超出12题！",
            type: "warning",
            customClass: "mzindex",
          });
          return true;
        }
      }
    },
    /**
     * 判断小题号类型 (1)
     */
    checkXTHToNumberDouble(value) {
      if (value == "(1)") {
        if (this.formData.end > 12) {
          this.$message({
            message: "此类题型小题号不能超出12题！",
            type: "warning",
            customClass: "mzindex",
          });
          return true;
        }
      }
    },
    /**
     * 判断小题号类型 ①
     */
    checkXTHToNumber(value) {
      if (value == "①") {
        if (this.formData.end > 10) {
          this.$message({
            message: "此类题型小题号不能超出10题！",
            type: "warning",
            customClass: "mzindex",
          });
          return true;
        }
      }
    },
    addItems() {
      if (this.subject) {
        if (this.isClickAdd === 0) {
          if (
            this.subject.start > this.formData.start ||
            this.subject.end < this.formData.end ||
            this.formData.items.length === 0
          ) {
            const obj = JSON.parse(JSON.stringify(this.formData));
            this.changeObj = {
              ...this.changeObj,
              start: obj.start,
              end: obj.end,
              score: obj.score,
              tCount: obj.tCount,
            };
            this.isClickAdd = 1;
          } else {
            const obj = JSON.parse(JSON.stringify(this.subject));
            this.changeObj = {
              ...this.changeObj,
              start: obj.start,
              end: obj.end,
              score: obj.score,
              tCount: obj.tCount,
            };
          }
        } else {
          if (
            this.changeObj.start > this.formData.start ||
            this.changeObj.end < this.formData.end ||
            this.formData.items.length === 0
          ) {
            const obj = JSON.parse(JSON.stringify(this.formData));
            this.changeObj = {
              ...this.changeObj,
              start: obj.start,
              end: obj.end,
              score: obj.score,
              tCount: obj.tCount,
            };
          }
        }
      } else {
        // 新增
        if (!this.changeObj.start) {
          const obj = JSON.parse(JSON.stringify(this.formData));
          this.changeObj = {
            ...this.changeObj,
            start: obj.start,
            end: obj.end,
            score: obj.score,
            tCount: obj.tCount,
          };
        } else {
          if (
            this.changeObj.start > this.formData.start ||
            this.changeObj.end < this.formData.end ||
            this.formData.items.length === 0
          ) {
            const obj = JSON.parse(JSON.stringify(this.formData));
            this.changeObj = {
              ...this.changeObj,
              start: obj.start,
              end: obj.end,
              score: obj.score,
              tCount: obj.tCount,
            };
          }
        }
      }
      this.creatItems("formData");
    },
    clear() {
      this.formData.items = [];
    },
    dialogClose() {
      if (this.subject) {
        this.subject.oldSubject =
          this.subject && JSON.parse(JSON.stringify(this.subject));
      }
      this.$emit("input", false);
    },
    deleteItem(scope) {
      const idx = scope.$index;
      this.formData.deleteItem(idx);
    },
    submitBlank(data) {
      if (this.submitDisabled) {
        return false;
      }
      this.submitDisabled = true;
      let timer = setTimeout(() => {
        this.submitDisabled = false;
        clearTimeout(timer);
      }, 500);
      if (!this.formData.items.length) {
        this.$message({
          type: "warning",
          message: "列表不能为空，请点击‘+’号按钮，添加题号！",
          customClass: "mzindex",
        });
        return;
      }
      // this.$refs["formData"].validate((valid) => {
      if (this.formData.items && this.formData.items.length) {
        if (this.changeObj.start) {
          const obj = JSON.parse(JSON.stringify(this.changeObj));
          data = { ...data, score: obj.score, tCount: obj.tCount };
        }
        const { items } = this.formData;
        data.start = items[0].no;
        data.end = items[items.length - 1].no;
        data.totalScore = 0; // 总分重新计算
        items.forEach((item) => {
          data.totalScore += item.score;
        });
        data = new BlankModel(data);
        this.$emit("submit-blank", data);
        if (this.subject) {
          this.subject.oldSubject = JSON.parse(JSON.stringify(this.subject));
        }
        setTimeout(() => {
          this.formData = new BlankModel(this.type);
        }, 300);
      }
      // });
    },
  },

  data(ctx) {
    var thValidate = (rule, value, callback) => {
      value = Number(value);
      // let validV = new RegExp("^([1-9]\\d{0,}\\.){0,2}[1-9]\\d{0,}$");
      // let validV = new RegExp("^[^\d]$");
      if (!value) {
        callback(new Error("必填"));
      }
      // else if (!validV.test(value)) {
      //   callback(new Error("请正确填写"));
      // }
      else if (
        ctx.formData.xTHValue == XTH_TYPE_KONG &&
        rule.field === "start" &&
        value > Number(ctx.formData.end)
      ) {
        callback(new Error("开始题号过大"));
      } else if (
        ctx.formData.xTHValue == XTH_TYPE_KONG &&
        rule.field === "end" &&
        value < Number(ctx.formData.start)
      ) {
        callback(new Error("开始题号过大"));
      } else {
        if (rule.field === "start") {
          this.$refs["end_inp"].clearValidate();
        } else {
          this.$refs["start_inp"].clearValidate();
        }
        callback();
      }
    };
    let thValidateEmpty = (rule, value, callback) => {
      if (!value) {
        callback(new Error("必填"));
      } else {
        callback();
      }
    };
    return {
      thDescText: "至",
      formData: new BlankModel(this.type),
      isClickAdd: 0,
      changeObj: {},
      rulesFrom: {
        th: [{ validator: thValidateEmpty, trigger: "blur" }],
        name: [{ validator: thValidateEmpty, trigger: "blur" }],
        tType: [{ validator: thValidate, trigger: "blur" }],
        start: [{ validator: thValidate, trigger: "blur" }],
        end: [{ validator: thValidate, trigger: "blur" }],
        score: [{ validator: thValidate, trigger: "blur" }],
        optionNum: [{ validator: thValidate, trigger: "blur" }],
        tCount: [{ validator: thValidate, trigger: "blur" }],
        partScore: [{ validator: thValidate, trigger: "blur" }],
      },
    };
  },
  watch: {
    value: {
      //handler:'test',
      handler(val) {
        if (val) {
          if (this.subject) {
            this.subject.oldSubject =
              this.subject && JSON.parse(JSON.stringify(this.subject));
            const obj = JSON.parse(JSON.stringify(this.subject));
            this.changeObj = {
              ...this.changeObj,
              score: obj.score,
              tCount: obj.tCount,
            };
          }
        }
        if (this.subject) {
          this.formData = new BlankModel(this.subject.oldSubject);
          // this.clearHistoryTopicFormData();
        } else {
          setTimeout(() => {
            this.formData = new BlankModel(this.type);
            this.clearHistoryTopicFormData();
          }, 500);
        }
      },
      immediate: true,
    },
    "formData.xTHValue": {
      handler(val) {
        if (val != XTH_TYPE_KONG) {
          // 代表小题号不为空
          this.thDescText = "共";
        } else {
          this.thDescText = "至";
        }
      },
    },
    "formData.eachBlankScore"(val) {
      if (val) {
        this.formData.columnCount =
          this.formData.columnCount > 3 ? 3 : this.formData.columnCount;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >
.el-form-item span {
  padding: 0 10px;
}
.el-form--inline .el-form-item .el-input-number {
  width: 80px;
}
.limit-title {
  .el-checkbox__inner {
    padding: 0 !important;
  }
}
</style>
